export const tiposDeGif = [
	{puntos: 10, tipo: "congratulations"},
	{puntos: 6, tipo: "not bad"},
	{puntos: 3, tipo: "failure"},
];
